@if (facade.enableLockedOverlay$ | async) {
  <div class="wrapper">
    <div class="overlay">
      <div class="message">
        <h1>Your subscription to Eliqua.CX has expired.</h1>
        <h3>Exp. Date: {{ facade.subscriptionEndDate$ | async | date }}</h3>
        <h3>
          Please contact support at <a href="mailto: support@inteliqua.com"> support&#64;inteliqua.com </a>for assistance.
        </h3>
      </div>
    </div>
  </div>
}
